module.exports = __webpack_public_path__ + "static/chalkboard-math-3d4ac9a4c0ab2aff7d3e596c6c7af63c.jpg";